import React, { useEffect, useState } from 'react';
import {
  parseIds,
  MAX_LENGTH,
  sanitizeIds,
  mapToIdValue,
  sortStudentsAZ,
  ReusableAccordion,
  applyMergeInclude,
  applyExclusiveInclude,
  buildPresetFormValues,
  validateSelectionLimit,
  matchesDropdownFilters,
  getMatchedStudentsBySingleInput,
} from './ssaCommonUtils';
import {
  getSnackBar,
  getOptionLabel,
  useNotification,
  getButtonSpinner,
  showBackdropLoader,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import {
  GridWrapper,
  HelperTextForm,
  WarningHelperText,
} from 'components/Ui/styled';
import {
  SsaTextBox,
  FilterPresetButton,
  FilterDataButtonGroup,
  FilterPresetEditButton,
  FilterPresetLoaderGrid,
} from './ssaComponentStyled';
import {
  ssaStudentColumns,
  getSsaStudentProfileListData,
} from './ssaStudentsDataGrid';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { filterPresetSuccess } from 'constants';
import MDTypography from 'components/MDTypography';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSelectedSsaStudent,
  setSelectedStudentsList,
  setSelectedMultipleStudents,
  setSelectedSsaStudentDetails,
  setSelectedStudentHeadingDetails,
  setAllSsaStudents,
} from '../store/ssaStudentDetailSlice/ssaStudentDetailSlice';
import {
  getAllStudents,
  getStudentProfileFilterOptions,
} from 'layouts/studentManagement/services/studentProfileApi';
import CircularProgress from '@mui/material/CircularProgress';
import CustomizedSnackbars from 'components/snackbar/Snackbar';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { HeadingWrapperBox } from 'layouts/inventory/Inventory.styled';
import FormInputDropdown from 'components/Common/Forms/FormInputDropDown';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';
import { displaySnackbar } from 'components/snackbar/store/SnackbarSlice';
import { getSearchedStudents } from 'layouts/students/service/studentsApi';
import {
  getFilterPreset,
  putFilterPreset,
  postFilterPreset,
  getFilterPresets,
  deleteFilterPreset,
} from 'layouts/studentSuccessAdvocate/FilterPresets/services/filterPresetsApi';
import CommonDeleteDialog from 'components/Common/CommonDeleteDialog/CommonDeleteDialog';
import { attendanceTagsDropdown } from 'layouts/applications/attendance/common/constants';
import { getSemesterDetails } from 'layouts/applications/attendance/services/attendanceApis';
import { FormInputAutoCompleteSearch } from 'components/Common/Forms/FormAutoCompleteSearch';
import { setSelectedStudents } from 'layouts/spedNotes/spedNotes/store/spedNotesSlice/spedNoteSlice';
import { resetSelectedStudentTrackers } from '../store/ssaStudentTrackersSlice/ssaStudentTrackersSlice';
import FilterPresetsDialog from 'layouts/studentSuccessAdvocate/FilterPresets/components/FilterPresetsDialog';
import { resetSidebarSelectedStudent } from '../store/ssaSidenavBarStudentDetails/ssaSidenavBarStudentDetailsSlice';
import { setStudentProfileFilterOptions } from 'layouts/studentManagement/store/studentProfileFilterOptionsSlice/studentProfileFilterOptionsSlice';
const SsaComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { NotificationPopup, handleErrorResponse } = useNotification();

  const [student, setStudent] = useState(null);
  const [expanded, setExpanded] = useState({
    presetSearch: true,
    presetButtons: true,
    studentFilters: true,
  });

  const [studentOptions, setStudentOptions] = useState([]);
  const [studentSearchQuery, setStudentSearchQuery] = useState('');
  const [isStudentSearchLoading, setIsStudentSearchLoading] = useState(false);
  const [filterPresetsListData, setFilterPresetsListData] = useState({
    isLoading: false,
    rows: [],
  });
  const [studentList, setStudentList] = useState({
    isLoading: false,
    rows: [],
    pageSize: 2000,
  });
  const totalRows = studentList?.rows?.length;
  const [selectedIds, setSelectedIds] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectionError, setSelectionError] = useState('');
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [currentSemester, setCurrentSemester] = useState('');
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [filterPresetsForm, setFilterPresetsForm] = useState(null);
  const [isNewFilterPreset, setIsNewFilterPreset] = useState(false);
  const [presetError, setPresetError] = useState({
    presetName: '',
    message: '',
  });

  const CREATE_NEW = 'CREATE_NEW';

  const presetDropdownOptions = [
    { id: CREATE_NEW, value: 'Create New' },
    ...(filterPresetsListData?.rows || []).map((p) => ({
      id: p.presetName,
      value: p.presetName,
    })),
  ];

  const studentProfileFilterOptions = useSelector(
    (state) => state.studentProfileFilterOptions,
  );
  const { allSsaStudents } = useSelector((state) => state.ssaStudentDetail);

  const { allStudentTypes, allInstructors, allCourseNames, allGradeLevels } =
    studentProfileFilterOptions ?? {};

  const allInstructorsOptions = mapToIdValue(allInstructors);
  const allCourseNamesOptions = mapToIdValue(allCourseNames);
  const allGradeLevelsOptions = mapToIdValue(allGradeLevels);
  const allStudentTypesOptions = mapToIdValue(allStudentTypes);

  const defaultValue = {
    tags: [],
    types: [],
    search: '',
    grades: [],
    courses: [],
    includeId: '',
    excludeId: '',
    student_id: '',
    instructors: [],
    selectedWeek: '',
    includeIdsExclusive: true,
    presetSelector: 'CREATE_NEW',
  };

  const useFunction = useForm({ defaultValues: defaultValue });
  const { setValue, formState, control, watch, reset } = useFunction;
  const { errors } = formState;

  const selectedTags = watch('tags') || [];
  const includeId = watch('includeId') || '';
  const excludeId = watch('excludeId') || '';
  const selectedTypes = watch('types') || [];
  const selectedGrades = watch('grades') || [];
  const selectedCourses = watch('courses') || [];
  const searchedNameOrId = watch('search') || '';
  const selectedPresetName = watch('presetSelector');
  const selectedInstructors = watch('instructors') || [];
  const includeIdsExclusive = watch('includeIdsExclusive');

  useEffect(() => {
    if (studentSearchQuery?.length >= 1) fetchSearchedStudents();
  }, [studentSearchQuery]);

  const fetchSearchedStudents = async () => {
    try {
      setIsStudentSearchLoading(true);
      const searchedStudents = await getSearchedStudents(
        studentSearchQuery,
        false,
        false,
        20,
      );
      setStudentOptions(searchedStudents?.items || []);
      setIsStudentSearchLoading(false);
    } catch (error) {
      setIsStudentSearchLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleStudentSelect = (val) => {
    const studentId = val?.studentId || '';
    setStudent(val);
    setValue('student_id', studentId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    dispatch(setSelectedStudentHeadingDetails(val));
  };

  useEffect(() => {
    clearCommonState();
    fetchCurrentSemester();
    // fetchFilterPresetsListData();
    fetchStudentProfileFilterOptions();
    dispatch(resetSidebarSelectedStudent());
    dispatch(resetSelectedStudentTrackers());
    dispatch(setSelectedMultipleStudents(false));
  }, []);

  const fetchCurrentSemester = async () => {
    const semesters = await getSemesterDetails();
    setCurrentSemester(semesters[0]);
  };

  const fetchStudentProfileFilterOptions = async () => {
    if (allCourseNames?.length > 0) return;
    try {
      const studentProfileFilterOptionsData =
        await getStudentProfileFilterOptions();
      dispatch(setStudentProfileFilterOptions(studentProfileFilterOptionsData));
    } catch (error) {
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const fetchFilterPresetsListData = async () => {
    try {
      setFilterPresetsListData((prev) => ({ ...prev, isLoading: true }));
      const data = await getFilterPresets();

      setFilterPresetsListData((prev) => ({
        ...prev,
        isLoading: false,
        rows: data,
      }));
      setPresetError({ presetName: '', message: '' });
    } catch (error) {
      setFilterPresetsListData((prev) => ({ ...prev, isLoading: false }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchAllStudents();
  }, []);

  useEffect(() => {
    dispatch(setSelectedStudentsList([]));
  }, []);

  useEffect(() => {
    dispatch(setSelectedStudents([]));
    dispatch(setSelectedSsaStudent(''));
    dispatch(setSelectedSsaStudentDetails({}));
  }, []);

  const fetchAllStudents = async () => {
    if (allSsaStudents?.length > 0) {
      setStudentList((prev) => ({
        ...prev,
        rows: allSsaStudents,
      }));
      fetchFilterPresetsListData();
      return;
    }

    setStudentList({ ...studentList, isLoading: true });
    setFilterPresetsListData((prev) => ({ ...prev, isLoading: true }));
    try {
      const studentsListData = await getAllStudents();
      const processedRows = getSsaStudentProfileListData(studentsListData);
      setStudentList({
        ...studentList,
        isLoading: false,
        rows: processedRows,
      });
      dispatch(setAllSsaStudents(processedRows));
      fetchFilterPresetsListData();
    } catch (error) {
      setStudentList({ ...studentList, isLoading: false });
      setFilterPresetsListData((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const handleToggleSelect = (id, checked) => {
    setSelectedIds((prev) => {
      const updated = checked
        ? [...prev, id]
        : prev.filter((item) => item !== id);

      const errorMsg = validateSelectionLimit(updated.length);
      setSelectionError(errorMsg);

      const limitedArray = updated.slice(0, MAX_LENGTH);
      dispatch(setSelectedStudents(limitedArray));
      return updated;
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const filteredIds = filteredRows.map((r) => r.id);
      setSelectedIds(filteredIds);

      const errorMsg = validateSelectionLimit(filteredIds.length);
      setSelectionError(errorMsg);

      const limitedArray = filteredIds.slice(0, MAX_LENGTH);
      dispatch(setSelectedStudents(limitedArray));
    } else {
      setSelectedIds([]);
      setSelectionError('');
      dispatch(setSelectedStudents([]));
    }
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prev) => ({ ...prev, [panel]: isExpanded }));
  };

  const handlePresetClick = (preset) => {
    setPresetError({ presetName: '', message: '' });
    /* ---------------------------------------------
  1️⃣ Fill form values automatically
  --------------------------------------------- */
    const presetFields = [
      'tags',
      'types',
      'grades',
      'search',
      'courses',
      'instructors',
    ];

    presetFields.forEach((field) => {
      setValue(
        field,
        preset[field] || (Array.isArray(preset[field]) ? [] : ''),
      );
    });

    setValue('includeId', preset.includeIds || '');
    setValue('excludeId', preset.excludeIds || '');
    setValue('includeIdsExclusive', !!preset.includeIdsExclusive);

    /* ---------------------------------------------
  2️⃣ Parse IDs
  --------------------------------------------- */
    const includeIds = parseIds(preset?.includeIds);
    const excludeIds = parseIds(preset?.excludeIds);

    /* --------------------------------------------------
  3️⃣ Apply filtering logic using common utils
  -------------------------------------------------- */
    const allRows = studentList?.rows;
    let filtered = allRows?.filter((s) =>
      matchesDropdownFilters(s, {
        selectedTypes: preset?.types || [],
        selectedGrades: preset?.grades || [],
        selectedTags: preset?.tags || [],
        selectedCourses: preset?.courses || [],
        selectedInstructors: preset?.instructors || [],
      }),
    );

    filtered =
      preset?.includeIdsExclusive && includeIds.length
        ? applyExclusiveInclude(filtered, includeIds, excludeIds)
        : applyMergeInclude(filtered, allRows, includeIds, excludeIds);

    if (!filtered?.length) {
      setPresetError({
        presetName: preset?.presetName,
        message: `Preset '${preset?.presetName}' matches no students. Please adjust the preset.`,
      });
      return;
    }

    /* ---------------------------------------------
  4️⃣ Format data for state and apply MAX_LENGTH limit
  --------------------------------------------- */
    const studentsDetails = filtered?.slice(0, MAX_LENGTH)?.map((s) => ({
      studentId: s.id,
      grade: s.gradeLevel,
      lastName: s.lastName,
      firstName: s.firstName,
      semester: currentSemester,
    }));

    const sortedStudents = sortStudentsAZ(studentsDetails);

    /* ---------------------------------------------
  5️⃣ Dispatch final values with first alphabetical student
  --------------------------------------------- */
    dispatch(setSelectedMultipleStudents(true));
    dispatch(setSelectedStudentsList(sortedStudents));
    const firstAlphabeticalStudent = sortedStudents[0];
    dispatch(setSelectedSsaStudent(firstAlphabeticalStudent.studentId));
    dispatch(setSelectedStudentHeadingDetails(firstAlphabeticalStudent));

    navigate('/ssa/online-attendance-compliance-app');
  };

  const pageSizeChange = pageSizeChangeHandler(setStudentList);

  const handleNewPreset = () => {
    setIsNewFilterPreset(true);
    setFilterPresetsForm(null);
    setOpenFilterDialog(true);
  };

  const editClickHandler = async (preset) => {
    try {
      setIsFormLoading(true);
      const data = await getFilterPreset(preset?.presetName);

      setFilterPresetsForm(data);
      setIsNewFilterPreset(false);
      setOpenFilterDialog(true);
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleStudentRedirect = () => {
    if (!student) return;

    const singleStudent = {
      grade: student.grade,
      semester: student.semester,
      lastName: student.lastName,
      studentId: student.studentId,
      firstName: student.firstName,
    };

    dispatch(setSelectedStudentsList([singleStudent]));
    dispatch(setSelectedSsaStudent(student.studentId));
    dispatch(setSelectedStudentHeadingDetails(singleStudent));

    navigate('/ssa/online-attendance-compliance-app');
  };

  const handleBeginSession = () => {
    let studentsToUse = [];
    if (selectedIds?.length === 0) {
      // No students selected → use all filtered rows
      studentsToUse = filteredRows;
    } else {
      // Use selected students
      const limitedSelectedIds = selectedIds?.slice(0, MAX_LENGTH);

      studentsToUse = studentList?.rows?.filter((std) =>
        limitedSelectedIds?.includes(std?.id),
      );
    }

    if (!studentsToUse?.length) return;

    const limitedStudents = studentsToUse?.slice(0, MAX_LENGTH);
    const studentsDetails = limitedStudents?.map((std) => ({
      studentId: std.id,
      firstName: std.firstName,
      lastName: std.lastName,
      grade: std.gradeLevel,
      semester: currentSemester,
    }));

    const sortedStudents = sortStudentsAZ(studentsDetails);

    // Store entire list for Prev/Next navigation
    dispatch(setSelectedStudentsList(sortedStudents));

    const firstAlphabeticalStudent = sortedStudents[0];
    dispatch(setSelectedSsaStudent(firstAlphabeticalStudent.studentId));
    dispatch(setSelectedStudentHeadingDetails(firstAlphabeticalStudent));
    dispatch(resetSidebarSelectedStudent());
    dispatch(setSelectedMultipleStudents(true));
    navigate('/ssa/online-attendance-compliance-app');
  };

  useEffect(() => {
    const result = applyFilters();
    setFilteredRows(result);
  }, [
    includeId,
    excludeId,
    selectedTags,
    selectedTypes,
    selectedGrades,
    selectedCourses,
    studentList.rows,
    searchedNameOrId,
    selectedInstructors,
    includeIdsExclusive,
  ]);

  const applyFilters = () => {
    const allRows = studentList?.rows || [];

    const includeIds = parseIds(includeId);
    const excludeIds = parseIds(excludeId);
    const searchValue = searchedNameOrId.trim();

    /* --------------------------------------------------
    1️⃣ Apply Dropdown Filters (clean + DRY)
  -------------------------------------------------- */
    let filtered = allRows.filter((s) =>
      matchesDropdownFilters(s, {
        selectedTypes,
        selectedGrades,
        selectedTags,
        selectedCourses,
        selectedInstructors,
      }),
    );

    /* --------------------------------------------------
    2️⃣ Apply Include / Exclude Logic (fully DRY)
  -------------------------------------------------- */
    filtered =
      includeIdsExclusive && includeIds.length
        ? applyExclusiveInclude(filtered, includeIds, excludeIds)
        : applyMergeInclude(filtered, allRows, includeIds, excludeIds);

    /* --------------------------------------------------
    3️⃣ Apply Search (Name or ID)
  -------------------------------------------------- */
    if (searchValue) {
      filtered = getMatchedStudentsBySingleInput(searchValue, filtered);
    }

    return filtered;
  };

  const clearCommonState = () => {
    setSelectedIds([]);
    setFilteredRows(studentList.rows);

    dispatch(setSelectedStudents([]));
    dispatch(setSelectedSsaStudent(''));
    dispatch(setSelectedSsaStudentDetails({}));
    dispatch(setSelectedMultipleStudents(false));
    dispatch(setSelectedStudentHeadingDetails({}));
  };

  const handleClearFilters = () => {
    clearCommonState();
    reset(defaultValue);
    setPresetError({ presetName: '', message: '' });
  };

  useEffect(() => {
    if (!selectedPresetName) return;

    // CREATE NEW
    if (selectedPresetName === 'CREATE_NEW') {
      setIsEditMode(false);
      reset(defaultValue);
      return;
    }

    const preset = filterPresetsListData.rows.find(
      (p) => p.presetName === selectedPresetName,
    );

    if (!preset) return;

    setIsEditMode(true);

    const formValues = buildPresetFormValues(preset, defaultValue);
    reset(formValues);
  }, [selectedPresetName, filterPresetsListData.rows]);

  const handleSavePreset = async () => {
    setIsFormLoading(true);
    const snackBar = getSnackBar(filterPresetSuccess);
    const presetName = isEditMode
      ? watch('presetSelector')
      : watch('presetName');

    if (!presetName?.trim()) {
      NotificationPopup('Preset name is required');
      return;
    }

    const payload = {
      presetName,
      tags: selectedTags,
      types: selectedTypes,
      grades: selectedGrades,
      courses: selectedCourses,
      instructors: selectedInstructors,
      includeIds: sanitizeIds(includeId),
      excludeIds: sanitizeIds(excludeId),
      includeIdsExclusive: includeIdsExclusive,
    };
    try {
      if (isEditMode) {
        await putFilterPreset(payload, presetName);
      } else {
        await postFilterPreset(payload);
      }

      dispatch(displaySnackbar(snackBar));
      await fetchFilterPresetsListData();
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleDeletePreset = async () => {
    setOpenDeleteDialog(true);
  };

  const resetPresetForm = () => {
    reset({
      ...defaultValue,
      presetSelector: CREATE_NEW,
    });

    setIsEditMode(false);
    clearCommonState();
  };

  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <CustomizedSnackbars />
      <MDBox>
        <Card>
          <HeadingWrapperBox>
            <MDTypography variant="h5" fontWeight="medium">
              All Active Students
            </MDTypography>
            <MDTypography variant="h5">
              Total Students : {totalRows}
            </MDTypography>
          </HeadingWrapperBox>

          <GridWrapper container spacing={2}>
            {/* --- Quick Start Session --- */}
            <Grid item xs={12}>
              <ReusableAccordion
                title="Quick Start Session"
                expanded={expanded?.presetSearch}
                onChange={handleAccordionChange('presetSearch')}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={10}>
                    <FormInputAutoCompleteSearch
                      value={student}
                      label="Search students"
                      options={studentOptions}
                      error={!!errors?.student_id}
                      placeholder="Search students"
                      getOptionLabel={getOptionLabel}
                      setSelectedInput={handleStudentSelect}
                      helperText={errors?.student_id?.message}
                      isSearchloading={isStudentSearchLoading}
                      setInputSearchQuery={setStudentSearchQuery}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    {getButtonSpinner(
                      false,
                      handleStudentRedirect,
                      'Start Session',
                    )}
                  </Grid>
                </Grid>
              </ReusableAccordion>
            </Grid>

            {/* --- Preset Buttons --- */}
            <Grid item xs={12}>
              <ReusableAccordion
                title="Quick Start with Preset"
                expanded={expanded.presetButtons}
                onChange={handleAccordionChange('presetButtons')}
              >
                <Grid container spacing={2}>
                  {/* New Preset Button */}
                  {/* <Grid item xs={12} textAlign="right">
                    <Button
                      variant="text"
                      onClick={handleNewPreset}
                      disabled={filterPresetsListData?.isLoading}
                    >
                      New Preset
                    </Button>
                  </Grid> */}

                  {filterPresetsListData?.isLoading ? (
                    <FilterPresetLoaderGrid item xs={12} py={2}>
                      <CircularProgress size={32} />
                    </FilterPresetLoaderGrid>
                  ) : (
                    /* ---------- Actual preset buttons ---------- */
                    filterPresetsListData?.rows?.map((preset) => (
                      <Grid item xs={6} sm={4} md={3} key={preset.resourceId}>
                        <FilterDataButtonGroup variant="outlined">
                          <FilterPresetButton
                            onClick={() => handlePresetClick(preset)}
                          >
                            {preset.presetName}
                          </FilterPresetButton>

                          {/* <FilterPresetEditButton
                            onClick={(e) => {
                              e.stopPropagation();
                              editClickHandler(preset);
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </FilterPresetEditButton> */}
                        </FilterDataButtonGroup>
                        {presetError.presetName === preset.presetName && (
                          <HelperTextForm error sx={{ mt: 0.5 }}>
                            {presetError.message}
                          </HelperTextForm>
                        )}
                      </Grid>
                    ))
                  )}
                </Grid>
              </ReusableAccordion>
            </Grid>

            <Grid item xs={12}>
              <ReusableAccordion
                title="Filter Students"
                expanded={expanded.studentFilters}
                onChange={handleAccordionChange('studentFilters')}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12} textAlign="right">
                    <Button variant="text" onClick={handleClearFilters}>
                      Clear Filters
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <FormInputDropdown
                      multiple
                      name="grades"
                      label="Grades"
                      control={control}
                      checked={selectedGrades}
                      options={allGradeLevelsOptions}
                      defaultValue={defaultValue.grades}
                      renderValue={(selected) => selected.join(', ')}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormInputDropdown
                      multiple
                      name="types"
                      label="Student Types"
                      control={control}
                      checked={selectedTypes}
                      options={allStudentTypesOptions}
                      defaultValue={defaultValue.types}
                      renderValue={(selected) => selected.join(', ')}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormInputDropdown
                      multiple
                      name="instructors"
                      label="Instructors"
                      control={control}
                      checked={selectedInstructors}
                      options={allInstructorsOptions}
                      defaultValue={defaultValue.instructors}
                      renderValue={(selected) => selected.join(', ')}
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <FormInputDropdown
                      multiple
                      name="courses"
                      label="Courses"
                      control={control}
                      checked={selectedCourses}
                      options={allCourseNamesOptions}
                      defaultValue={defaultValue.courses}
                      renderValue={(selected) => selected.join(', ')}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormInputDropdown
                      multiple
                      name="tags"
                      label="Tags"
                      control={control}
                      checked={selectedTags}
                      options={attendanceTagsDropdown}
                      defaultValue={defaultValue.tags}
                      renderValue={(selected) => selected.join(', ')}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormInputText
                      type="text"
                      multiline={true}
                      name="search"
                      control={control}
                      label="Search (Name or ID)"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormInputText
                      rows={2}
                      type="text-area"
                      multiline={true}
                      name="includeId"
                      control={control}
                      label="Include IDs"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormInputText
                      rows={2}
                      type="text-area"
                      multiline={true}
                      name="excludeId"
                      control={control}
                      label="Exclude IDs"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormInputSwitch
                      control={control}
                      name="includeIdsExclusive"
                      label="Only include matching students"
                    />
                  </Grid>

                  <Grid item xs={12} md={9}>
                    <FormInputDropdown
                      control={control}
                      name="presetSelector"
                      label="Select Preset"
                      defaultValue="CREATE_NEW"
                      options={presetDropdownOptions}
                    />
                  </Grid>
                  <Grid item xs={12} md={3} alignContent="end">
                    <Button
                      variant="text"
                      disabled={!watch('presetName')}
                      onClick={handleSavePreset}
                    >
                      {isEditMode ? 'Update' : 'Save'}
                    </Button>
                    {isEditMode && (
                      <Button
                        variant="text"
                        disabled={isFormLoading}
                        onClick={handleDeletePreset}
                      >
                        Delete
                      </Button>
                    )}
                  </Grid>
                  {!isEditMode && (
                    <Grid item xs={12} md={6}>
                      <FormInputText
                        name="presetName"
                        control={control}
                        label="Preset Name"
                        rules={{ required: 'Preset name is required' }}
                      />
                    </Grid>
                  )}
                </Grid>
              </ReusableAccordion>
            </Grid>
          </GridWrapper>
          <MDBox mb={2}></MDBox>
          <GridWrapper container spacing={2}>
            <HeadingWrapperBox>
              <MDTypography variant="h5" fontWeight="medium">
                Filtered Students {`(${filteredRows.length} of ${totalRows})`}
              </MDTypography>
              <Button
                variant="text"
                onClick={handleBeginSession}
                // disabled={!selectedIds.length}
              >
                Begin Session
              </Button>
            </HeadingWrapperBox>
          </GridWrapper>

          {selectionError && (
            <SsaTextBox>
              <WarningHelperText sx={{ mb: 1 }}>
                ⚠️{selectionError}
              </WarningHelperText>
            </SsaTextBox>
          )}

          <DeltaDataGrid
            listData={{ ...studentList, rows: filteredRows }}
            columns={ssaStudentColumns(
              selectedIds,
              handleToggleSelect,
              handleSelectAll,
              filteredRows,
            )}
            setListData={pageSizeChange}
            defaultSortField="studentNumber"
          />
        </Card>
      </MDBox>
      <CommonDeleteDialog
        snakBarName="filter preset"
        commonDeleteId={selectedPresetName}
        openDeleteDialog={openDeleteDialog}
        commonDeleteApi={deleteFilterPreset}
        fetchData={async () => {
          await fetchFilterPresetsListData();
          resetPresetForm();
        }}
        setOpenDeleteDialog={setOpenDeleteDialog}
        contentText="Are you sure you want to delete this filter preset?"
      />
      {openFilterDialog && (
        <FilterPresetsDialog
          open={openFilterDialog}
          setOpen={setOpenFilterDialog}
          isNewFilterPreset={isNewFilterPreset}
          filterPresetsForm={filterPresetsForm}
          setFilterPresetsForm={setFilterPresetsForm}
          setIsNewFilterPreset={setIsNewFilterPreset}
          isFormLoading={isFormLoading}
          fetchFilterPresetsListData={fetchFilterPresetsListData}
        />
      )}

      <NotificationPopup />
    </>
  );
};

export default SsaComponent;
